import axios, { AxiosRequestConfig, AxiosError } from "axios";
import APIResponse from "@/types/APIResponse";

type HttpRequest = {
    url: string,
    method?: "get" | "post" | "put" | "delete" | "GET" | "POST" | "PUT" | "DELETE",
    auth?: boolean,
    body?: any,
    params?: any,
    token?: string
};

export default class BaseService {
    static async perform<T>(request: HttpRequest): Promise<T> {
        try {
            const config: AxiosRequestConfig = {
                baseURL: process.env.VUE_APP_HOST + "/api",
                url: request.url,
                method: request.method,
                headers: {
                    "Content-Type": "application/json"
                },
                data: request.body,
                params: request.params
            };

            if (request.auth && config.headers !== undefined) {
                config.headers["Authorization"] = `Basic ${request.token ?? sessionStorage.getItem("access-token")}`;
            }

            const response = (await axios(config)).data as APIResponse<T>;

            if (response.error) {
                throw new Error(response.message ?? "Errore sconosciuto");
            }

            return response.data!;

        } catch (error) {
            if (error instanceof AxiosError) {
                throw (error as AxiosError).response?.data;
            } else {
                throw error;
            }
        }
    }
}